// extracted by mini-css-extract-plugin
export default {"footerButtons":"CustomAlert_modal_footerButtons__ryIUO"};